export default class ValidaDataOcorrencia {
    
    static valida(dataHora) {

        return new Promise((resolve,reject) => {
            try {
                const dataAcontecimento = validarDataAcontecimento(dataHora)
                resolve(dataAcontecimento)
            } 
            catch (msgErro) {
                reject(msgErro)
            }
        })
    }
}

const validarDataAcontecimento = dataAcontecimento => {
    if (!dataAcontecimento) {
        return '';
    }
    return dataAcontecimento;
}